module.exports = __webpack_public_path__ + "img/ts_2010.cc89fb46.jpg";